import React from 'react';
import { LogoImg, SFXImg } from './elements';
import { PageWrapper, Container } from '@Main/elements';
import { P, Absolute } from '@helpers';
import bg from '@static/about/sfx-bg_1.png';

export const Philosophy = ({t}) => {
    return (
      <PageWrapper darkMode={true} bgImage={bg} height="519px">
        <Container paddingTop='60px' marginLeft='42px' paddingBottom='60px'>
          <LogoImg/>
          <Absolute top="205px" left="102px">
            <SFXImg/>
            <P weight='500' size='40px' height='35px' marginTop='29px'>{t("Corporate philosophy")}</P>
          </Absolute>
        </Container>
     </PageWrapper>
  );
};
